const es = {
  'helper.select.isSearchable': 'Comienza a escribir y selecciona de la lista',
  'helper.select.location.placeholder': 'Ej. Ciudad de México, México',
};

export default es;
